import React, { FC, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IDocumentsTableProps } from '../../types';
import { IFileNode } from 'src/models/documentsLibrary/types';
import { Button } from 'src/common';

interface IProps {
  file: IDocumentsTableProps;
  onAttach?: (fileId: string) => void;
  files: IFileNode[];
  isLoading?: boolean;
}

export const DocumentsAttach: FC<IProps> = props => {
  const { file, onAttach, files, isLoading } = props;
  const { id: fileId } = file;

  const { t } = useTranslation();

  const alreadyAttached = useMemo(() => {
    return files && files.some(file => file.id === fileId);
  }, [files, fileId]);

  const onAttachFile = useCallback(() => {
    onAttach && onAttach(fileId);
  }, [onAttach, fileId]);

  return (
    <Button onClick={onAttachFile} loading={isLoading} type={'link'} disabled={alreadyAttached}>
      {t('Common.attach')}
    </Button>
  );
};

export default DocumentsAttach;
